// @flow
import React from 'react'
import './styles.scss'
import CopyrightNotice from '@ta-interaktiv/react-copyright-notice'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import ShareButtons from '@ta-interaktiv/react-share-buttons'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'

type Props = {
  articleId: string,
  publicationDate: number
}

export function Footer ({ articleId, publicationDate }: Props) {
  return (
    <footer className='ui vertical padded grey segment ta footer'>
      <div className='ui container'>
        <div className='ui grid'>
          <div className='two column stackable row'>
            <div className='column'>
              <table className='ui small very basic definition infographic unstackable table'>
                <tbody>
                  <tr>
                    <td>Texte</td>
                    <td>
                      <em>Tobi</em>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <em>Tobis</em> Lehrer
                    </td>
                    <td>
                      Daniel Barben (Textbausteine), Fabian Renz (Beratung)
                    </td>
                  </tr>
                  <tr>
                    <td>Programmierung</td>
                    <td>Yvan Da Silva, Kaspar Manz</td>
                  </tr>
                  <tr>
                    <td>Datenexperte</td>
                    <td>Mathias Born</td>
                  </tr>
                  <tr>
                    <td>Projektleitung</td>
                    <td>Titus Plattner, Marc Brupbacher, Didier Orel</td>
                  </tr>
                  <tr>
                    <td>Veröffentlicht</td>
                    <td>
                      <TimestampFormatter timestamp={publicationDate} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='column'>
              <FeedbackMessage />

              <ShareButtons className='basic' articleId={articleId} />
            </div>
          </div>

          <div className='two column stackable row'>
            <div className='column'>
              <CopyrightNotice />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js